
import { Component, Vue } from "vue-property-decorator";
import { Message } from "element-ui";
import {
  addRemark,
  addShippingOrder,
  cancelHenganLoadingPlan,
  getContainerTypeConfigurationInfoForWarehouse,
  getHenganLoadingPlans,
  releaseContainerType,
  updateShippingOrder
} from "@/api/hengan-loading-plan";
import Pagination from "@/components/Pagination/index.vue";
import {
  getShippingOrderContainerTypeReleasedInfo,
  getShippingOrders,
} from "@/api/shipping-order";
import { ShippingOrderModel } from "@/model/shipping-order";
import ContainerTypeConfiguration from "@/views/system-management/information/ContainerTypeConfiguration.vue";
import ContainerTypeReleasedInfo, {
  ContainerTypeReleasedInfoModel
} from "@/views/components/ContainerTypeReleasedInfo.vue";
import {
  deleteContainerTypeRelations,
  updateContainerTypeLoadingType,
} from "@/api/container-type";
import { exportJson2Excel } from "@/utils/excel";
import { formatJson } from "@/utils";
import { cloneDeep } from "lodash";
import ConfigContainerTypeComponent, {
  ContainerTypeConfigurationInfo,
} from "@/views/components/ConfigContainerTypeComponent.vue";
import {
  LoadingInfo,
} from "@/model/HenganLoadingPlanModels";
import {
  deleteLoadingInfosForSeller,
  saveLoadingInfosFowSeller,
} from "@/api/loading-info";
import {
  ConfigContainerTypeRequest,
  CreateLoadingInfoRequest,
} from "@/views/warehouse-management/HenganLoadingPlanManagementForWarehouse.vue";
import HenganLoadingPlanFormDialog from "@/views/outbound-management/components/HenganLoadingPlanFormDialog.vue";

@Component({
  name: "HenganLoadingPlan",
  components: {
    HenganLoadingPlanFormDialog,
    ContainerTypeReleasedInfo,
    ContainerTypeConfiguration,
    ConfigContainerTypeComponent,
    Pagination,
  },
})
export default class extends Vue {
  private configContainerTypeDialogVisibleTitle = '出库单';
  private henganLoadingPlans:any = [];
  private shippingOrders: ShippingOrderModel[] = [];
  private addShippingOrderDialogVisible = false;
  private releaseContainerTypeDialogVisible = false;
  private currentRow: HenganLoadingPlanTableRowData =
    new HenganLoadingPlanTableRowData();
  private isLoadingShippingOrders = false;
  private isLoadingContainerTypeReleasedInfo = false;
  private currentSelectedShippingOrderId: string = null;
  private containerTypeReleasedInfo: ContainerTypeReleasedInfoModel =
      new ContainerTypeReleasedInfoModel();
  public sumbitBindShippingOrderDialogloading = false;
  private listQuery = {
    pageNumber: 1,
    pageSize: 20,
    customerAbbreviationOrCode: null,
    code: null,
    states: null,
    startDate: null,
    endDate: null,
    dateRange: null,
    bookingOrderCode: null
  };
  private total = 0;
  private shownCancelPopoverRowId: string = null;
  private addRemarkDialogVisible = false;
  private configContainerTypeDialogVisible = false;
  private configContainerTypeDialogEditable = true;
  private containerTypeConfigurationInfo: ContainerTypeConfigurationInfo =
    new ContainerTypeConfigurationInfo();
  private updateShippingOrderDialogVisible = false;
  private curSelectedShippingOrderId = "";
  private loadingRowId = "";
  private updateShippingOrderLoading = false;

  created() {
    this.getList();
  }

  private exportExcel() {
    const data = this.henganLoadingPlans.map((value) => {
      return {
        isTransshipDelivery: value.transshipDelivery ? "是" : "否",
        isLoadingInOneOrMorePlaces: value.loadingInOneOrMorePlaces
          ? "是"
          : "否",
        stateDesc: value.state.desc,
        ...value,
      };
    });
    const headers = [
      "出库计划单号",
      "客户简称",
      "创建日期",
      "是否驳货",
      "是否多地装柜",
      "状态",
      "订舱号",
      "海运提单号",
      "柜型及数量",
      "备注",
    ];
    const fieldNames = [
      "code",
      "customerAbbr",
      "createdAt",
      "isTransshipDelivery",
      "isLoadingInOneOrMorePlaces",
      "stateDesc",
      "shippingOrderCode",
      "",
      "",
      "remark",
    ];
    exportJson2Excel(
      headers,
      formatJson(fieldNames, data),
      `出库计划（销售）-${new Date()}`
    );
  }

  private handleCreateHenganLoadingPlan() {
    (this.$refs.planFormDialog as any).openCreate();
  }

  private gotoDocumentFlow(data) {
    this.$router.push({name: "DocumentFlow", params: {type: "HENG_AN_LOADING_PLAN", documentId: data.id}});
  }

  private handleUpdateHenganLoadingPlan(rowData) {
    (this.$refs.planFormDialog as any).openEdit(rowData);
  }

  private showAddRemarkDialog(row: HenganLoadingPlanTableRowData) {
    this.currentRow = cloneDeep(row);
    this.addRemarkDialogVisible = true;
  }

  private async doAddRemark() {
    await addRemark(this.currentRow.id, { remark: this.currentRow.remark });
    this.addRemarkDialogVisible = false;
    await this.getList();
  }

  private async getList() {
    if (this.listQuery.dateRange) {
      this.listQuery.startDate = this.listQuery.dateRange[0];
      this.listQuery.endDate = this.listQuery.dateRange[1];
    }
    const params = { ...this.listQuery };
    params.dateRange = null;
    await getHenganLoadingPlans(params)
      .then((res: any) => {
        this.total = res.total;
        this.henganLoadingPlans = res.content;
        this.henganLoadingPlans.map((item,index) => {item.sn = index + 1})
      })
      .catch((error) => {
        Message.error({
          message: error.message,
          duration: 2000,
        });
      });
  }

  private checkImages(row: HenganLoadingPlanTableRowData) {
    this.$router.push({
      name: "ImageManagement",
      params: { bizType: "hengan-loading-plan", objectId: row.id },
    });
  }

  private checkDetail(row: HenganLoadingPlanTableRowData) {
    this.$router.push({
      name: "HenganLoadingPlanDetail",
      params: { id: row.id },
    });
  }

  private async onAddShippingOrderClick(row: HenganLoadingPlanTableRowData) {
    this.currentRow = row;
    this.addShippingOrderDialogVisible = true;
    await getShippingOrders(this.currentRow.customerId, this.currentRow.companyCode).then((res: any) => {
      this.shippingOrders = res;
    });
  }

  private async onAddShippingOrderConfirmClick() {
    this.sumbitBindShippingOrderDialogloading = true;
    try {
      await addShippingOrder(this.currentRow.id, {
        shippingOrderId: this.currentSelectedShippingOrderId,
      });
      this.currentSelectedShippingOrderId = null;
      this.shippingOrders = [];
      await this.getList();
      this.addShippingOrderDialogVisible = false;
    }catch (e){
      console.error(e);
    }finally {
      this.sumbitBindShippingOrderDialogloading = false;
    }
  }

  private handleReleaseContainerType(row: HenganLoadingPlanTableRowData) {
    this.currentRow = row;
    this.releaseContainerTypeDialogVisible = true;
    this.isLoadingContainerTypeReleasedInfo = true;
    this.getContainerTypeReleasedInfo(row.shippingOrderId);
  }

  private getContainerTypeReleasedInfo(shippingOrderId) {
    getShippingOrderContainerTypeReleasedInfo(shippingOrderId, {
      loadingPlanId: this.currentRow.id,
      type: "HENGAN_LOADING_PLAN",
    })
      .then((res: any) => {
        this.containerTypeReleasedInfo = res;
        this.isLoadingContainerTypeReleasedInfo = false;
      })
      .catch(() => (this.isLoadingContainerTypeReleasedInfo = false));
  }

  private async doReleaseContainerType(
    data: [{ id: string; loadingInOneOrMorePlaces: string }]
  ) {
    if (data.length < 1) {
      Message.error({
        message: "请选择柜型",
        duration: 2000,
      });
      return;
    }
    await releaseContainerType(this.currentRow.id, { containerTypes: data });
    this.getContainerTypeReleasedInfo(this.currentRow.shippingOrderId);
  }

  private async doRemoveContainerType(containerTypeId: string) {
    let data = {"loadingPlanId":this.currentRow.id,"loadingPlanType":"HENGAN_LOADING_PLAN"};
    await deleteContainerTypeRelations(containerTypeId, data);
    this.getContainerTypeReleasedInfo(this.currentRow.shippingOrderId);
  }

  private async doChangeLoadingType(
    containerTypeId: string,
    loadingInOneOrMorePlaces: boolean
  ) {
    await updateContainerTypeLoadingType(containerTypeId, {
      loadingInOneOrMorePlaces,
    });
    this.getContainerTypeReleasedInfo(this.currentRow.shippingOrderId);
  }


  private showConfigContainerTypeDialog(
    row: HenganLoadingPlanTableRowData,
    configurationEditable = true,
    title: string
  ) {
    this.configContainerTypeDialogVisibleTitle = title
    this.currentRow = row;
    this.configContainerTypeDialogVisible = true;
    this.configContainerTypeDialogEditable = configurationEditable;
    this.getContainerTypeConfigurationInfo();
  }

  private getContainerTypeConfigurationInfo() {
    getContainerTypeConfigurationInfoForWarehouse(this.currentRow.id).then(
      (res: any) => {
        this.containerTypeConfigurationInfo = res;
      }
    );
  }

  private async onSaveLoadingInfos(
    createDeliveryList: boolean,
    loadingInfos: LoadingInfo[]
  ) {
    const request: ConfigContainerTypeRequest =
      new ConfigContainerTypeRequest();
    request.henganLoadingPlanId = this.currentRow.id;
    request.createDeliveryList = createDeliveryList;
    request.loadingInfos = loadingInfos.map((value) => {
      const r: CreateLoadingInfoRequest = new CreateLoadingInfoRequest();
      Object.assign(r, value);
      r.henganCustomsPackingIds = value.customsPackingSet.map(
        (value) => value.id
      );
      r.containerTypeId = value.containerType?.id || value.containerTypeId;
      return r;
    });
    await saveLoadingInfosFowSeller(request);
    this.configContainerTypeDialogVisible = false;
    await this.getList();
  }

  private async onDeleteLoadingInfo(loadingInfoId: string) {
    await deleteLoadingInfosForSeller(loadingInfoId);
    this.getContainerTypeConfigurationInfo();
  }

  /**
   * 取消出库计划
   * @param henganLoadingPlanId
   * @private
   */
  private async cancelHenganLoadingPlan(henganLoadingPlanId: string) {
    await cancelHenganLoadingPlan(henganLoadingPlanId);
    this.shownCancelPopoverRowId = null;
    await this.getList();
  }
  private containerTypeIsLCL(containerTypeInfos: string[]): boolean{
    const LclIsExisted = containerTypeInfos.filter((value => value === "LCL*1"))[0];
    return !LclIsExisted;
  }

  private renderCusAbbr(prop, row) {
    if (row.pcNames && row.pcNames.length > 0){
      return `[${row.pcNames}]${prop}`
    }
    return prop
  }

  private async openUpdateShippingOrderDialog(row: HenganLoadingPlanTableRowData) {
    this.loadingRowId = row.id;
    this.currentRow = row;
    await getShippingOrders(this.currentRow.customerId, this.currentRow.companyCode).then((res: any) => {
      this.shippingOrders = res;
    });
    this.updateShippingOrderDialogVisible = true;
    this.curSelectedShippingOrderId = row.shippingOrderId;
    await this.$nextTick();
  }

  /**
   * 清空并关闭更新舱单对话框
   * @private
   */
  private clearUpdateShippingOrderDialog() {
    this.updateShippingOrderDialogVisible = false;
    this.curSelectedShippingOrderId = "";
    this.shippingOrders = [];
    this.loadingRowId = "";
  }

  /**
   * 更新舱单
   * @private
   */
  private async updateShippingOrder() {
    this.updateShippingOrderLoading = true;
    try {
      await updateShippingOrder(this.currentRow.id, this.curSelectedShippingOrderId);
      this.clearUpdateShippingOrderDialog();
    } catch (e) {
      console.error(e);
    } finally {
      this.updateShippingOrderLoading = false;
    }
  }

}

class HenganLoadingPlanTableRowData {
  id: string;
  code: string;
  customerAbbr: string;
  customerId: string;
  createdAt: Date;
  state: { name: string; desc: string };
  remark: string;
  transshipDelivery: boolean;
  transshipDeclaration: boolean;
  shippingOrderId: string;
  shippingOrderCode: string;
  loadingInOneOrMorePlaces: string;
  billOfLadingCode: string;
  deliveryListId: string;
  containerTypeInfos: string[];
  bookingOrderCodes: string;
  companyCode: string;
}

